import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Triangle from './Triangle.js';

const Triangles = (props) => { 
    return (
        <div className="triangles">
          <TriangleRow isTop={true}/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow isBottom={true}/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
          <TriangleRow/>
        </div>);
};

const TriangleRow = ({isBottom, isTop}) => {
    let className = "triangle-row";
    if (isTop) {
        className += " top";
    }
    return (
        <div className={className}>
          <Triangle isBottom={isBottom}/>
          <Triangle/>
          <Triangle isBottom={isBottom}/>
          <Triangle/>
          <Triangle isBottom={isBottom}/>
          <Triangle/>
          <Triangle/>
          <Triangle/>
          <Triangle/>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Triangles);
